export default __webpack_public_path__ + "static/media/errors1.aa3732ad.svg";